var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticClass:"d-block",attrs:{"value":_vm.selected,"placeholder":_vm.plc || 'Продукт',"filterable":"","clearable":"","size":_vm.size},on:{"input":_vm.dispatch}},_vm._l((_vm.products),function(product){return _c('el-option',{key:product.id,attrs:{"label":product.name,"value":product.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }